import { useCallback, useState } from 'react';

export const useCollapsibleItem = (initialState: boolean): [boolean, () => void] => {
    const [isOpened, setOpened] = useState<boolean>(initialState);
    const onClick = useCallback(() => setOpened(!isOpened), [isOpened]);

    return [isOpened, onClick];
};
